import _ from "lodash";
import {
	GET_APPROVALS,
	GET_APPROVAL
} from "./actions"
import { APPROVE_STEP, UNAPPROVE_STEP, REJECT_STEP } from "./steps/actions";

export function ApprovalsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_APPROVALS}_FULFILLED`: {
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_APPROVAL}_FULFILLED`: {
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem, "id")
			newState[id] = newItem
			return newState;
		}
		case `${REJECT_STEP}_FULFILLED`:
		case `${UNAPPROVE_STEP}_FULFILLED`:
		case `${APPROVE_STEP}_FULFILLED`: {
			let newState = _.clone(state);
			const newStep = action?.payload?.data;
			const approval_id = _.get(newStep, "approval_id")
			if (approval_id) {
				let approval = newState[approval_id]
				if (approval) {
					const findStep = _.findKey(approval?.steps, { id: newStep.id })
					if (findStep) {
						approval.steps[findStep] = newStep
					}
					if (action.type === `${REJECT_STEP}_FULFILLED` || newStep.approval_rejected) {
						approval.rejected = true
						approval.approved = false
						approval.your_turn = false
						approval.actionable_step_id = null
						approval.status = "declined"
					} else {
						const allStepsApproved = _.every(approval?.steps, (step) => step.approved)
						approval.approved = allStepsApproved
						approval.status = allStepsApproved ? "approved" : "pending"
					}
				}
			}
			return newState;
		}

		default:
			return state;
	}
}

// Move this to the reducer page
// import { ApprovalsReducer } from "modules/approvals/reducer"

// approvals:ApprovalsReducer,
